var React = require('react');

function Chatonline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"icon_chat_online","data-name":"icon chat online","transform":"translate(-90 -1831)"},[React.createElement("rect",{"id":"nền_74x30","data-name":"nền 74x30","width":"74","height":"30","transform":"translate(90 1831)","fill":"#fff","key":0}),React.createElement("path",{"id":"chat_online","data-name":"chat online","d":"M84.8,190.42h9.46v-2H84.8Zm0-3.8H99.2v-2H84.8Zm0-3.8H99.2v-2H84.8ZM80,200V178a1.932,1.932,0,0,1,.595-1.395A1.906,1.906,0,0,1,82,176h20a2.069,2.069,0,0,1,2,2v15.2a2.069,2.069,0,0,1-2,2H84.8Zm2-4.83,1.97-1.97H102V178H82ZM82,178v0Z","transform":"translate(35 1658)","key":1})]));
}

Chatonline.defaultProps = {"width":"74","height":"30","viewBox":"0 0 74 30"};

module.exports = Chatonline;

Chatonline.default = Chatonline;
